import { api } from "@api/api";
import { BookActivity } from "@modules/bookActivities/types";
import { BookActivityFormValues } from "@modules/bookActivities/validations";

export async function editBookActivityService(
  id: string,
  data: BookActivityFormValues
): Promise<BookActivity> {
  if (typeof data.image === "string") {
    delete data.image;
  }

  const { data: bookActivity } = await api.patch<BookActivity>(
    `v1/book_activity_admin/${id}/`,
    {
      ...data,
      image: undefined,
    }
  );

  if (data.image) {
    const imageFormData = new FormData();
    imageFormData.append("image", data.image);

    await api.patch<BookActivity>(
      `v1/book_activity_admin/${id}/`,
      imageFormData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  }

  return bookActivity;
}
